import { createQueryData } from '../helpers/createQueryData';

const endPoint = 'Acceptance/stage_address_life_cycle_by_stage_id';

const { useQuery } = createQueryData({ endPoint });

const useAvailableStagesQuery = ({ params: { stageId } = {}, options }) => {
  return useQuery({
    params: { stageId },
    options: {
      enabled: Boolean(stageId),
      ...options,
    },
  });
};

export { useAvailableStagesQuery };
